export default "__VITE_PUBLIC_ASSET__fe6a07b5__"